import { CommonService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useCommonRepairOrderQuotesQueryKey = 'VNCCommonRepairOrderQuotes';

export const useCommonRepairOrderQuotes = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: number,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonRepairOrderQuotes>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getCommonRepairOrderQuotes>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useCommonRepairOrderQuotesQueryKey, ...(queryKey ?? [filter])],
    () => CommonService.getCommonRepairOrderQuotes(filter),
    options
  );
